import { includes } from "lodash";
import { createSelector } from "reselect";
import { isAssetDetail as isAssetDetailSelector } from "selectors/location";

const assetSelector = (state) => state.asset;

export const assetNamesSelector = createSelector(
  (state) => state.assetNames,
  (assetNames) => assetNames
);

export const assetDetailSelector = createSelector(
  assetSelector,
  isAssetDetailSelector,
  (asset, isAssetDetail) => (isAssetDetail ? asset : undefined)
);

export const assetDealsSelector = createSelector(
  assetSelector,
  (state) => state.assetDeals,
  (asset, assetDeals) => assetDeals.filter((assetDeal) => assetDeal.assetId === asset.id)
);

export const assetDealsOverviewSelector = createSelector(
  (state) => state.assets,
  (state) => state.assetDeals,
  (assets, assetDeals) => {
    const assetShowingDeals = assets.find((asset) => asset.isDealsExpanded);

    if (assetShowingDeals) {
      return assetDeals
        .filter((assetDeal) => includes(assetShowingDeals.dealIds, assetDeal.deal.id))
        .map((assetDeal) => assetDeal.deal);
    }

    return [];
  }
);

export const isLoadingAsset = createSelector(
  (state) => state.loading,
  (loading) => loading.asset
);

export const assetContactsSelector = createSelector(
  assetSelector,
  (state) => state.assetContacts,
  (asset, contacts) => contacts.filter((contact) => contact.assetId === asset.id)
);

export const isLoadingAssetDeals = createSelector(
  (state) => state.loading,
  (loading) => loading.assetDeals
);

export const isLoadingContacts = createSelector(
  (state) => state.loading,
  (loading) => loading.contacts
);

export const firstStageSelector = createSelector(
  assetSelector,
  (asset) => asset.portfolio.dealStages[1]
);

export default assetDetailSelector;
